import React, { useState, useEffect } from 'react';

import DiagonalFill from '../DiagonalFill/DiagonalFill';
import Modal from '../Modal/Modal';

import classes from './Thumbnail.module.css';

const DEFAULT_PICTURE = '/pictures/other/cake-placeholder.png'

const nextPictureURL = ( pictures, next, setNext ) => {
    if ( Array.isArray( pictures ) ) {
        if ( next >= pictures.length ) {
            setNext( 1 );
            return pictures[ 0 ] || DEFAULT_PICTURE;
        } else {
            setNext( next + 1 );
            return pictures[ next ];
        }
    }
    return pictures || DEFAULT_PICTURE;
}

const Thumbnail = ( { pictures, small, bigger, refresh, noDefault, className, onClick } ) => {
    const [ rotating, setRotating ] = useState( null );
    const [ showPreview, setShowPreview ] = useState( false );
    const [ pictureURL, setPictureURL ] = useState( DEFAULT_PICTURE );
    const [ next, setNext ] = useState( 1 );

    if ( noDefault && ( ! pictures || ( Array.isArray( pictures ) && pictures.length === 0 ) ) ) {
        return null;
    }

    useEffect( () => {
        if ( pictures ) { // In some cases the pictures are set after the thumbnail is built
            setPictureURL( nextPictureURL( pictures, 0, setNext ) );
            if ( Array.isArray( pictures ) && pictures.length > 1 ) {
                if ( ! rotating ) {
                    const rotate = setInterval( () => setPictureURL( null ), 3000 );
                    setRotating( rotate )
                    return () => clearInterval( rotating );
                }
            } else if ( rotating ) {
                clearInterval( rotating );
                setRotating( null );
            }
        }
    }, [ pictures, rotating ] );

    useEffect( () => {
        if ( pictures && ! pictureURL ) {
            setPictureURL( nextPictureURL( pictures, next, setNext ) );
        }
    }, [ pictures, pictureURL, next ] );

    const thumbnailClasses = [ 
        classes.Thumbnail, 
        small && classes.Small,
        bigger && classes.Bigger,
        className
    ].join( ' ' );

    if ( ! pictureURL || pictureURL === 'NONE' ) {
        return <div className={ thumbnailClasses }>{ pictureURL !== 'NONE' && '?' }</div>
    }
    const name = pictureURL.substr( pictureURL.lastIndexOf( '/' ) );

    return (
        <React.Fragment>
            <img src={ `${ pictureURL }${ refresh ? `?t=${ Date.now() }` : '' }` } alt={ name } 
                className={ thumbnailClasses } 
                onClick={ onClick || ( () => setShowPreview( true ) ) }
            />

            { showPreview &&
                <Modal onClick={ () => setShowPreview( false ) } className={ classes.PreviewModal }>
                    <div className={ classes.Preview } >
                        <div className={ classes.PreviewBuffer } ></div>
                        <img src={ pictureURL } 
                            alt={ name } className={ classes.PreviewImage }
                        />
                        <div className={ classes.PreviewBuffer } ></div>
                    </div>
                    <div className={ classes.PreviewBackdrop } >
                        <DiagonalFill />
                    </div>
                </Modal>
            }
        </React.Fragment>
    );
}

export default Thumbnail;